
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as sendF394BFimpcFjnYSH0G4sr8IxBwcOY5Z9BhRNdkBChr4Meta } from "/app/layers/send/pages/send.vue?macro=true";
import { default as indexgWpwy0JIAL38PlOXsTgjeQ03lbHkUt_45mgBGEBpoIS1QMeta } from "/app/layers/base/pages/index.vue?macro=true";
import { default as loginR_siMw92PSJRGhoKaxhA_IJTGKWz2hMfe4U_45115n0M0Meta } from "/app/layers/auth/pages/login.vue?macro=true";
import { default as registerSFm8EKQf8A7ADeeSYCssb6IiHTMseTWsjnneeEQD4QcMeta } from "/app/layers/auth/pages/register.vue?macro=true";
import { default as settingsrYYxTGynv15qWILUWaV8RryrVEhyw6cKBczt1wLs8o0Meta } from "/app/layers/settings/pages/settings.vue?macro=true";
import { default as analyticsy6ZId_eDx0j0Rcxc2Atfdj5V1oqe86d3x0zlQ8B0GY0Meta } from "/app/layers/documents/pages/analytics.vue?macro=true";
import { default as dashboardcyVdF3N_6ocre4tIlX_4tZY54ff_K3_xuuBfrDVI_45TQMeta } from "/app/layers/dashboard/pages/dashboard.vue?macro=true";
import { default as documentsp6vl_EzKl8j__3K6QVLE_45Jv_keuTtDE8X3irbRK_i8IMeta } from "/app/layers/documents/pages/documents.vue?macro=true";
import { default as forbidden7C5myPiVosZ2juqKja3KIeoYdv2SeQdp9grC2mFbWdAMeta } from "/app/layers/documents/pages/forbidden.vue?macro=true";
import { default as maintenancekVFIadQnqXTFJPv8jQaHzPZSOuPprFTbm_458l07rvaCAMeta } from "/app/layers/base/pages/maintenance.vue?macro=true";
import { default as _91id_93AP6rbzGL4pAOBydOdA4lbo_45vlUsr9KQxDWaunFa65lsMeta } from "/app/layers/documents/pages/document/[id].vue?macro=true";
import { default as reset_45passwordB9_45WGwIqiPIpq7KvCu6dlNTrV7YCRZgmsEnoT7UxtzwMeta } from "/app/layers/auth/pages/reset-password.vue?macro=true";
import { default as forgot_45passwordiPE0u0f7HvnxcZuFSMjyh8y1HCy1jV7I5eqvuZPjAVQMeta } from "/app/layers/auth/pages/forgot-password.vue?macro=true";
import { default as session_45expired_45iaiFYw8U1AmkrVZwIeANFIi5TrgTX_mwhQ2VhzaE24Meta } from "/app/layers/documents/pages/session-expired.vue?macro=true";
import { default as signature_45signingsdf_xQy4hPy6JJJIkzuiAFNHevry1EdXTGV2Uhg1jCEMeta } from "/app/layers/sign/pages/signature-signing.vue?macro=true";
import { default as document_45not_45foundIqpKE5gh2QbTC4j8hk8AsFGRVJ7GvRiJfj3225YZ6dQMeta } from "/app/layers/documents/pages/document-not-found.vue?macro=true";
import { default as unauthorized_45accessXB2KrxmL6WFeVJhuXHmG03JdOnSYtmhd83lCdMmQbw8Meta } from "/app/layers/documents/pages/unauthorized-access.vue?macro=true";
export default [
  {
    name: "send",
    path: "/send",
    meta: { ...(sendF394BFimpcFjnYSH0G4sr8IxBwcOY5Z9BhRNdkBChr4Meta || {}), ...{"middleware":["no-cache"]} },
    component: () => import("/app/layers/send/pages/send.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexgWpwy0JIAL38PlOXsTgjeQ03lbHkUt_45mgBGEBpoIS1QMeta || {},
    component: () => import("/app/layers/base/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: loginR_siMw92PSJRGhoKaxhA_IJTGKWz2hMfe4U_45115n0M0Meta || {},
    component: () => import("/app/layers/auth/pages/login.vue")
  },
  {
    name: "register",
    path: "/register",
    meta: registerSFm8EKQf8A7ADeeSYCssb6IiHTMseTWsjnneeEQD4QcMeta || {},
    component: () => import("/app/layers/auth/pages/register.vue")
  },
  {
    name: "settings",
    path: "/settings",
    meta: { ...(settingsrYYxTGynv15qWILUWaV8RryrVEhyw6cKBczt1wLs8o0Meta || {}), ...{"middleware":["no-cache"]} },
    component: () => import("/app/layers/settings/pages/settings.vue")
  },
  {
    name: "analytics",
    path: "/analytics",
    meta: { ...(analyticsy6ZId_eDx0j0Rcxc2Atfdj5V1oqe86d3x0zlQ8B0GY0Meta || {}), ...{"middleware":["no-cache"]} },
    component: () => import("/app/layers/documents/pages/analytics.vue")
  },
  {
    name: "dashboard",
    path: "/dashboard",
    meta: { ...(dashboardcyVdF3N_6ocre4tIlX_4tZY54ff_K3_xuuBfrDVI_45TQMeta || {}), ...{"middleware":["no-cache"]} },
    component: () => import("/app/layers/dashboard/pages/dashboard.vue")
  },
  {
    name: "documents",
    path: "/documents",
    meta: { ...(documentsp6vl_EzKl8j__3K6QVLE_45Jv_keuTtDE8X3irbRK_i8IMeta || {}), ...{"middleware":["no-cache"]} },
    component: () => import("/app/layers/documents/pages/documents.vue")
  },
  {
    name: "forbidden",
    path: "/forbidden",
    meta: forbidden7C5myPiVosZ2juqKja3KIeoYdv2SeQdp9grC2mFbWdAMeta || {},
    component: () => import("/app/layers/documents/pages/forbidden.vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    meta: maintenancekVFIadQnqXTFJPv8jQaHzPZSOuPprFTbm_458l07rvaCAMeta || {},
    component: () => import("/app/layers/base/pages/maintenance.vue")
  },
  {
    name: "document-id",
    path: "/document/:id()",
    meta: { ...(_91id_93AP6rbzGL4pAOBydOdA4lbo_45vlUsr9KQxDWaunFa65lsMeta || {}), ...{"middleware":["no-cache"]} },
    component: () => import("/app/layers/documents/pages/document/[id].vue")
  },
  {
    name: "reset-password",
    path: "/reset-password",
    meta: reset_45passwordB9_45WGwIqiPIpq7KvCu6dlNTrV7YCRZgmsEnoT7UxtzwMeta || {},
    component: () => import("/app/layers/auth/pages/reset-password.vue")
  },
  {
    name: "forgot-password",
    path: "/forgot-password",
    meta: forgot_45passwordiPE0u0f7HvnxcZuFSMjyh8y1HCy1jV7I5eqvuZPjAVQMeta || {},
    component: () => import("/app/layers/auth/pages/forgot-password.vue")
  },
  {
    name: "session-expired",
    path: "/session-expired",
    meta: session_45expired_45iaiFYw8U1AmkrVZwIeANFIi5TrgTX_mwhQ2VhzaE24Meta || {},
    component: () => import("/app/layers/documents/pages/session-expired.vue")
  },
  {
    name: "signature-signing",
    path: "/signature-signing",
    component: () => import("/app/layers/sign/pages/signature-signing.vue")
  },
  {
    name: "document-not-found",
    path: "/document-not-found",
    meta: document_45not_45foundIqpKE5gh2QbTC4j8hk8AsFGRVJ7GvRiJfj3225YZ6dQMeta || {},
    component: () => import("/app/layers/documents/pages/document-not-found.vue")
  },
  {
    name: "unauthorized-access",
    path: "/unauthorized-access",
    meta: unauthorized_45accessXB2KrxmL6WFeVJhuXHmG03JdOnSYtmhd83lCdMmQbw8Meta || {},
    component: () => import("/app/layers/documents/pages/unauthorized-access.vue")
  }
]